import { useContext } from 'react'

import RegulationsContext from 'contexts/RegulationsContext'

const useRegulations = () => {
  const context = useContext(RegulationsContext)

  if (context === undefined) {
    throw new Error(
      'useRegulations must be used within a RegulationsContext.Provider',
    )
  }

  return {
    regulationVersions: context.regulationVersions,
    isLoading: context.isLoading,
    isAccept: context.isAccept,
    hasError: context.hasError,
    acceptRegulation: context.acceptRegulation,
    tokenRaw: context.tokenRaw,
  }
}

export default useRegulations
